import Fetch from "@/assets/js/Fetch";

class Users {
  getList() {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "users/";

      Fetch.run(url).then(result => {
        resolve(result);
      });
    });
  }

  addUser(username, name, role, password) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "users/";

      let data = {
        username: username,
        name: name,
        role: role,
        password: password
      };

      Fetch.run(url, "PUT", data).then(result => {
        resolve(result.result);
      });
    });
  }

  removeUser(username) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "users/" + username + "/";

      Fetch.run(url, "DELETE").then(result => {
        resolve(result.result);
      });
    });
  }

  updateUser(username, name, role) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "users/" + username + "/";

      let data = {
        name: name,
        role: role
      };

      Fetch.run(url, "PUT", data).then(result => {
        resolve(result.result);
      });
    });
  }

  updateUserCredentials(username, password) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "users/" + username + "/credentials/";

      let data = {
        password: password
      };

      Fetch.run(url, "PUT", data).then(result => {
        resolve(result.result);
      });
    });
  }
}

export default new Users();
